import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { AuthProvider } from "./context/authContext";
import { AuthenticatedRoute } from "./components/Route/AuthenticatedRoute";
import { Settings } from "./pages/Settings";
import { Quote } from "./pages/Quote";
import { Ship } from "./pages/Ship";
import { Orders } from "./pages/Orders";
import { Order } from "./pages/Order";
import { QueryClient, QueryClientProvider } from "react-query";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { ShipProvider } from "./context/shipContext";
import { Summary } from "./pages/Summary";
import { HelmetProvider } from "react-helmet-async";
import TitleManager from "./components/Title/TitleManager";
import { Signup } from "./pages/Signup";
import { ResetPassword } from "./pages/ResetPassword";
import { ConfirmResetPassword } from "./pages/ConfirmResetPassword";
import { LoadScript } from "@react-google-maps/api";
import { STRIPE_PUBLIC_KEY } from "./constants";

const queryClient = new QueryClient();
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

export const App = () => {
  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      libraries={["places"]}
    >
      <HelmetProvider>
        <BrowserRouter basename="/">
          <AuthProvider>
            <Elements stripe={stripePromise}>
              <QueryClientProvider client={queryClient}>
                <ShipProvider>
                  <TitleManager />
                  <Routes>
                    <Route
                      path="/dashboard"
                      element={
                        <AuthenticatedRoute>
                          <Dashboard />
                        </AuthenticatedRoute>
                      }
                    >
                      <Route path="" element={<Summary />} />
                      <Route path="quote" element={<Quote />} />
                      <Route path="ship" element={<Ship />} />
                      <Route path="orders" element={<Orders />} />
                      <Route path="orders/:orderId" element={<Order />} />

                      <Route path="settings" element={<Settings />} />
                    </Route>
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/reset" element={<ResetPassword />} />
                    <Route
                      path="/reset/confirm"
                      element={<ConfirmResetPassword />}
                    />
                    <Route
                      path="*"
                      element={<Navigate to="/login" replace />}
                    />
                  </Routes>
                </ShipProvider>
              </QueryClientProvider>
            </Elements>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </LoadScript>
  );
};
